import {createSlice} from "@reduxjs/toolkit";

const initialLicenseSectorsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  licenseSectorForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const licenseSectorsSlice = createSlice({
  name: "licenseSectors",
  initialState: initialLicenseSectorsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getLicenseSectorById
    licenseSectorFetched: (state, action) => {
      state.actionsLoading = false;
      state.licenseSectorForEdit = action.payload.licenseSectorForEdit;
      state.error = null;
    },
    // findLicenseSectors
    licenseSectorsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createLicenseSector
    licenseSectorCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.license_sector);
    },
    // updateLicenseSector
    licenseSectorUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity._id === action.payload.licenseSector._id) {
          var newEntity = action.payload.licenseSector;
          newEntity.id = entity.id;
          return newEntity;
        }
        return entity;
      });
    },
    // deleteLicenseSector
    licenseSectorDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteLicenseSectors
    licenseSectorsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // licenseSectorsUpdateState
    licenseSectorsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
